'use strict';

module.exports = function sortByDesc(valueOrFunction) {
  return this.sortBy(valueOrFunction).reverse();
};


//////////////////
// WEBPACK FOOTER
// ./~/collect.js/dist/methods/sortByDesc.js
// module id = 1718
// module chunks = 2